import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class DatePicker extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let htmlContent = "";
    if (this.props.inputType === "datePicker") {
      htmlContent = (
        <ReactDatePicker
          selected={new Date()}
          onChange={() => this.props.datePickerValue}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dateFormat="MM-dd-yyyy"
          dropdownMode="select"
        />
      );
    } else if (this.props.inputType === "timePicker") {
      htmlContent = (
        <ReactDatePicker
          selected={new Date()}
          onChange={() => this.props.datePickerValue}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={1}
          // dateFormat="h:mm aa"
          dateFormat="h:mm aa"
          timeCaption="Time"
        />
      );
    } else if (this.props.inputType === "dateTimePicker") {
      htmlContent = (
        <ReactDatePicker
          selected={new Date()}
          onChange={() => this.props.datePickerValue}
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={1}
          dateFormat="MM-dd-yyyy h:mm aa"
          timeCaption="Time"
        />
      );
    }
    return <React.Fragment>{htmlContent}</React.Fragment>;
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/views/Audiences/SegmentQueryBuilder/DatePicker.jsx